import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["panel", "button"]

  close() {
    this.panelTarget.classList.add("hidden") 
  }
}
